<template>
  <AuthLayout title="HRDOS | Login Page">
    <div
      style="
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <div
        class="container blue lighten-5 z-depth-3"
        style="max-width: 420px; padding: 50px; border-radius: 32px"
      >
        <div class="center-align" style="margin-bottom: 40px">
          <div
            class="white circle z-depth-2 valign-wrapper center"
            style="
              width: 120px;
              height: 120px;
              justify-content: center;
              margin: 0 auto;
            "
          >
            <img src="@/assets/LTOlogo.png" style="width: 85%; height: auto" />
          </div>
          <h5 class="blue-text text-darken-4 bold">LTO HR-DOS</h5>
          <p>HUMAN RESOURCE<br />DATA ORGANIZATION SYSTEM</p>
        </div>

        <form @submit.prevent="login()">
          <div class="input-field"> 
            <input
              class="validate"
              :class="{ 'invalid': error }"
              id="email"
              type="text"
              v-model="user.login"
              required
            />
            <label for="email">Email or Username</label>
            <span
              class="helper-text"
              :data-error="error ? '' : 'Please enter your username or valid email address'"
              data-success=""
            ></span>
          </div>

          <div class="input-field">
            <input
              class="validate"
              :class="{ 'invalid': error }"
              id="password"
              :type="isPasswordVisible ? 'text' : 'password'"
              v-model="user.password"
              required
            />
            <label for="password">Password</label>
            <i 
              class="material-icons password-toggle" 
              @click="togglePasswordVisibility" 
              style="position: absolute; right: 3px; bottom: 33px; cursor: pointer; z-index: 2;"
            >
              {{ isPasswordVisible ? 'visibility_off' : 'visibility' }}
            </i>
            <span 
              class="helper-text" 
              :data-error="error ? '' : 'Please enter your password'" 
              data-success=""
            ></span>
          </div>

            <div>
              <p class="red-text" style="text-align: fixed; margin-top: -15px !important;">{{ error }}</p>
            </div>

          <p>
            <label>
              <input type="checkbox" v-model="user.remember" />
              <span>Remember Me</span>
            </label>
          </p>  
          
          <div style="margin-top: 50px; width: 100%">
            <button
              class="btn waves-light indigo darken-3 bold"
              type="submit"
              :disabled="loading"
              style="width: 100%; display: flex; justify-content: center; align-items: center;"
            >
              <span v-if="loading">Logging in...</span>
              <span v-else>Login</span>
              <i v-if="!loading" class="material-icons" style="margin-left: 8px">login</i>
            </button>
          </div>
          <div style="text-align: center; margin-top: 10px; margin-bottom: 20px;">
            <a href="#forgotPasswordModal" class="modal-trigger blue-text" style="font-size: 0.9rem;">Forgot Password?</a>
          </div>
        </form>
      </div>
    </div>

    <!-- Unapproved Modal -->
    <div id="unapprovedModal" class="modal unapproved-modal">
      <div class="modal-content center-align" style="padding: 40px 24px 20px;">
        <i class="material-icons orange-text text-darken-2" style="font-size: 4rem; margin-bottom: 10px;">pending_actions</i>
        <h5 style="font-weight: bold; color: #2c3e50; margin-top: 0;">Approval Pending</h5>
        <p class="grey-text text-darken-1" style="font-size: 1.1rem; line-height: 1.5;">
          Your account has not been approved yet. Please wait for the HR Administrator to review and validate your registration.
        </p>
      </div>
      <div class="modal-footer" style="display: flex; justify-content: center; background: transparent; padding-bottom: 30px;">
        <button class="modal-close btn blue darken-2" style="border-radius: 8px; font-weight: bold;">Okay, Understood</button>
      </div>
    </div>

    <!-- First Time Setup Modal -->
    <div id="firstTimeModal" class="modal first-time-modal">
      <div class="modal-content" style="padding: 30px 24px 10px;">
        <h5 class="blue-text text-darken-4 center-align" style="font-weight: bold; margin-bottom: 10px;">Welcome to HR-DOS!</h5>
        <p class="center-align grey-text text-darken-1" style="margin-bottom: 30px;">
          Since this is your first time logging in, please set up a new, secure password for your account.
        </p>

        <form @submit.prevent="updatePassword()">
          <div class="input-field">
            <input 
              id="new_password" 
              class="validate"
              :class="{ 'invalid': passwordError }"
              :type="isNewPasswordVisible ? 'text' : 'password'" 
              v-model="newPasswordData.password" 
              required minlength="8" 
            />
            <label for="new_password">New Password (Min 8 chars)</label>
            <i 
              class="material-icons password-toggle" 
              @click="isNewPasswordVisible = !isNewPasswordVisible" 
              style="position: absolute; right: 3px; bottom: 15px; cursor: pointer; z-index: 2;"
            >
              {{ isNewPasswordVisible ? 'visibility_off' : 'visibility' }}
            </i>
          </div>

          <div class="input-field">
            <input 
              id="confirm_password" 
              class="validate"
              :class="{ 'invalid': passwordError }"
              :type="isConfirmPasswordVisible ? 'text' : 'password'" 
              v-model="newPasswordData.password_confirmation" 
              required minlength="8" 
            />
            <label for="confirm_password">Confirm New Password</label>
            <i 
              class="material-icons password-toggle" 
              @click="isConfirmPasswordVisible = !isConfirmPasswordVisible" 
              style="position: absolute; right: 3px; bottom: 15px; cursor: pointer; z-index: 2;"
            >
              {{ isConfirmPasswordVisible ? 'visibility_off' : 'visibility' }}
            </i>
          </div>

          <p class="red-text center-align" v-if="passwordError">{{ passwordError }}</p>

          <div style="margin-top: 30px; display: flex; flex-direction: column; gap: 10px; align-items: center; margin-bottom: 10px;">
            <button type="submit" class="btn green darken-1" style="border-radius: 8px; width: 100%; font-weight: bold;" :disabled="passwordLoader">
              <span v-if="passwordLoader">Updating...</span>
              <span v-else>Update Password & Continue</span>
            </button>
            <button type="button" class="btn-flat grey-text text-darken-1" @click="cancelSetup" style="border-radius: 8px; width: 100%;" :disabled="passwordLoader">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Email Setup & Verification Modal -->
    <div id="emailVerificationModal" class="modal verification-modal">
      <div class="modal-content center-align" style="padding: 40px 24px 20px;">
        <i class="material-icons blue-text text-darken-2" style="font-size: 4rem; margin-bottom: 10px;">mark_email_unread</i>
        <h5 style="font-weight: bold; color: #2c3e50; margin-top: 0;">Link Your Email</h5>
        <p class="grey-text text-darken-1" style="font-size: 1.1rem; line-height: 1.5;">
          Please enter your work or personal email address. We will send a link to verify it.
        </p>

        <form @submit.prevent="submitEmailSetup" style="margin-top: 20px;">
          <div class="input-field text-left">
            <input 
              id="setup_email" 
              type="email" 
              class="validate"
              v-model="newEmail" 
              :disabled="verificationMessage !== ''"
              required 
            />
            <label for="setup_email">Email Address</label>
          </div>

          <p v-if="verificationMessage" class="green-text font-weight-bold" style="margin-top: -10px;">{{ verificationMessage }}</p>
          <p v-if="verificationError" class="red-text" style="margin-top: -10px;">{{ verificationError }}</p>

          <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; margin-top: 30px;">
            <button type="submit" class="btn blue darken-2" style="border-radius: 8px; font-weight: bold; width: 100%;" :disabled="resendLoader">
              <span v-if="resendLoader">Sending...</span>
              <span v-else>Send Verification Link</span>
            </button>
            <button type="button" class="btn-flat grey-text text-darken-1" @click="cancelVerification" style="border-radius: 8px; width: 100%;" :disabled="resendLoader">
              Cancel & Logout
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Forgot Password Modal -->
    <div id="forgotPasswordModal" class="modal" style="padding-bottom: 20px; width: 450px; max-width: 90%; border-radius: 16px;">
      <div class="modal-content center-align" style="padding: 40px 24px 10px;">
        <i class="material-icons blue-text text-darken-2" style="font-size: 4rem; margin-bottom: 10px;">lock_reset</i>
        <h5 style="font-weight: bold; color: #2c3e50; margin-top: 0;">Reset Password</h5>
        <p class="grey-text text-darken-1">
          Enter your registered email address and we will send you a secure link to reset your password.
        </p>

        <form @submit.prevent="submitForgotPassword" style="margin-top: 20px;">
          <div class="input-field text-left">
            <input 
              id="forgot_email" 
              type="email" 
              class="validate"
              v-model="forgotEmail" 
              required 
            />
            <label for="forgot_email">Email Address</label>
          </div>

          <p v-if="forgotMessage" class="green-text font-weight-bold">{{ forgotMessage }}</p>
          <p v-if="forgotError" class="red-text">{{ forgotError }}</p>

          <div style="margin-top: 30px;">
            <button type="submit" class="btn blue darken-2" style="border-radius: 8px; font-weight: bold; width: 100%; margin-bottom: 10px;" :disabled="forgotLoader">
              <span v-if="forgotLoader">Sending...</span>
              <span v-else>Send Reset Link</span>
            </button>
            <button type="button" class="btn-flat grey-text text-darken-1 modal-close" style="border-radius: 8px; width: 100%;">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>

  </AuthLayout>
</template>

<script>
import axios from "axios";
import {api, apiURL} from "../axios";
import AuthLayout from "./layout/AuthLayout.vue";

export default {
  name: "LoginView",
  components: {
    AuthLayout,
  },
  data() {
    return {
      user: {
        login: "",
        password: "",
        remember: false,
      },
      error: "",
      isPasswordVisible: false,
      loading: false,

      // For First Time Login Modal
      newPasswordData: {
        password: "",
        password_confirmation: "",
      },
      passwordError: "",
      passwordLoader: false,
      tempUser: null, // Holds the user object during first-time setup
      
      isNewPasswordVisible: false,
      isConfirmPasswordVisible: false,

      newEmail: "",
      resendLoader: false,
      verificationMessage: "",
      verificationError: "",

      forgotEmail: "",
      forgotLoader: false,
      forgotMessage: "",
      forgotError: "",
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },

    // ================= LOGIN =================
    async login() {
      this.error = '';
      this.loading = true;

      await axios.get(`${apiURL}/sanctum/csrf-cookie`, { withCredentials: true });

      api.post("/login", this.user)
      .then((response) => {
        const userObj = response.data.user;
        
        // 1. Check if email is verified first
        if (!userObj.email_verified_at) {
          this.tempUser = userObj; 
          const elem = document.getElementById('emailVerificationModal');
          const instance = window.M.Modal.getInstance(elem);
          if(instance) instance.open();
          this.loading = false;
          return; // Stop execution here
        }

        // 2. If verified, check if it's the first time logging in
        if (userObj.is_opened == 0) {
          this.tempUser = userObj;
          
          const elem = document.getElementById('firstTimeModal');
          const instance = window.M.Modal.getInstance(elem);
          if(instance) instance.open();
          this.loading = false;
        } else {
          // 3. Normal login
          localStorage.setItem("hrdos_user", JSON.stringify(userObj)); 
          this.$router.push(userObj.id == 1 ? "/dashboard" : "/my-profile");
        }
      })
      .catch((err) => {
        this.loading = false;

        const status = err.response && err.response.status;
        if (status === 401) {
          this.showError("Invalid login credentials...");
        } else if (status === 403) {
          const elem = document.getElementById('unapprovedModal');
          const instance = window.M.Modal.getInstance(elem);
          if(instance) instance.open();
        } else if (status === 429) {
          // Real server-side throttle (routes/api.php: throttle:5,1) —
          // this replaces the old fake client-side "3 tries" counter.
          const retryAfter = err.response.headers['retry-after'];
          this.showError(
            retryAfter
              ? `Too many attempts. Please try again in ${retryAfter}s.`
              : "Too many attempts. Please try again in a minute."
          );
        } else {
          this.showError("An error occurred.");
        }
      });
    },

    // ================= MODAL =================
    openChangePasswordModal() {
      this.changeError = "";
      const el = document.getElementById("changePasswordModal");
      
      if (el) {
        this.modalInstance = window.M.Modal.init(el, {
          dismissible: false,
        });
        this.modalInstance.open();
      }
    },

    updatePassword() {
      this.passwordError = "";

      if (this.newPasswordData.password !== this.newPasswordData.password_confirmation) {
        this.passwordError = "Passwords do not match.";
        return;
      }

      this.passwordLoader = true;

      // The HttpOnly cookie is already set from the login call, 
      // so Axios automatically sends it with this request! No headers needed.
      api.post("/first-time-password", this.newPasswordData)
        .then(() => {
          // Save the user data here as well for first-time logins
          if (this.tempUser) {
            localStorage.setItem("hrdos_user", JSON.stringify(this.tempUser));
          }

          const elem = document.getElementById('firstTimeModal');
          const instance = window.M.Modal.getInstance(elem);
          if(instance) instance.close();
          
          window.M.toast({html: 'Password setup complete!', classes: 'green rounded'});
          window.location.href = "/employees";
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.errors) {
             this.passwordError = "Password must be at least 8 characters.";
          } else {
             this.passwordError = "Server error. Please try again.";
          }
        })
        .finally(() => {
          this.passwordLoader = false;
        });
    },

    cancelSetup() {
      this.tempUser = null;
      this.newPasswordData.password = "";
      this.newPasswordData.password_confirmation = "";
      this.passwordError = "";

      this.isNewPasswordVisible = false;
      this.isConfirmPasswordVisible = false;

      const elem = document.getElementById('firstTimeModal');
      const instance = window.M.Modal.getInstance(elem);
      if(instance) instance.close();
      
      // Optionally log them out on the backend here if they cancel setup
    },

    submitEmailSetup() {
      this.resendLoader = true;
      this.verificationMessage = "";
      this.verificationError = "";

      // Send the entered email to your custom backend route
      api.post("/setup-email", { email: this.newEmail })
        .then(() => {
          this.verificationMessage = "Success! Please check your inbox for the link.";
          // this.newEmail = ""; 
        })
        .catch((err) => {
          // Handle Laravel validation errors (e.g., email already taken)
          if (err.response && err.response.status === 422) {
            this.verificationError = err.response.data.message || "This email is invalid or already in use.";
          } else {
            this.verificationError = "Failed to update email. Please try again.";
          }
        })
        .finally(() => {
          this.resendLoader = false;
        });
    },

    cancelVerification() {
      this.tempUser = null;
      this.newEmail = "";
      this.verificationMessage = "";
      this.verificationError = "";
      
      const elem = document.getElementById('emailVerificationModal');
      const instance = window.M.Modal.getInstance(elem);
      if(instance) instance.close();

      api.post('/logout').catch(() => {});
    },

    submitForgotPassword() {
      this.forgotLoader = true;
      this.forgotMessage = "";
      this.forgotError = "";

      // Ping Fortify's default forgot-password endpoint
      api.post("/forgot-password", { email: this.forgotEmail })
        .then(() => {
          // Fortify usually returns { status: "We have emailed your password reset link." }
          this.forgotMessage = "If this email is registered, a reset link has been sent.";
          this.forgotEmail = "";
        })
        .catch(() => {
          // Keep the error generic for security so attackers can't guess valid emails
          this.forgotError = "Something went wrong. Please check your email and try again.";
        })
        .finally(() => {
          this.forgotLoader = false;
        });
    },

    showError(msg) {
      this.error = msg;
      setTimeout(() => {
        this.error = "";
      }, 3000);
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (typeof window.M !== 'undefined') {
        const modals = document.querySelectorAll('.modal');
        window.M.Modal.init(modals, { dismissible: false }); 
      }
    });

    const loggedUser = localStorage.getItem("hrdos_user");

    if (loggedUser) {
      const user = loggedUser ? JSON.parse(loggedUser) : null;
      if (user.id == 1) {
        this.$router.push("/employees");
      }else{
        this.$router.push("/my-profile");
      }
    }

    
  },
};
</script>

<style scoped>
.password-toggle:hover {
  color: #1565c0;
}

.first-time-modal {
  padding-bottom: 20px !important;
  width: 550px !important;
  max-width: 90%;
  border-radius: 16px;
  min-height: auto;
  top: 20% !important;
}

.verification-modal {
  padding-bottom: 20px !important;
  width: 450px !important;
  max-width: 90%;
  border-radius: 16px;
  min-height: auto;
  top: 20% !important;
}

.unapproved-modal {
  padding-bottom: 20px !important;
  width: 550px !important;
  max-width: 90%;
  border-radius: 16px;
  min-height: auto;
  top: 30% !important;
}
</style>